import type { CarOwnerRecord } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { leasedCarFromOwners } from './leasedCarFromOwners';

type Props = {
  owners?: CarOwnerRecord[] | null;
  label: string;
};

export const LeasedCarBadge = ({ owners, label }: Props) => {
  const { isLeased, leasingCompanyName } = leasedCarFromOwners(owners);
  if (!isLeased) {
    return null;
  }

  return (
    <NoddiBadge variant='outline'>
      <NoddiIcon name='Car' size='small' />
      {leasingCompanyName ? `${label} · ${leasingCompanyName}` : label}
    </NoddiBadge>
  );
};
